export default () => {
    let activeSubmenuItem = document.querySelector('.sub-item.active')

    if (!activeSubmenuItem) {
        return
    }

    activeSubmenuItem.closest('li:not(.sub-item)').classList.add('active')
}
